// extracted by mini-css-extract-plugin
export default {"root":"Radio_root__HswWr","input":"Radio_input__M5pp3","radio":"Radio_radio__cJbNV","label":"Radio_label__taE7s"};